// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__3weC_","icon":"Checkbox_icon__2yxLt","label":"Checkbox_label__18RMf","disabled":"Checkbox_disabled__1S72Q","checked":"Checkbox_checked__2Gh-t"};